import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import {
  TPersonalDataTableRequest,
  TPersonalDataTableResponse,
} from '~/store/processing-personal/types.ts';

export const getPersonalDataTableSubmit = createAsyncThunk<
  TPersonalDataTableResponse,
  TPersonalDataTableRequest
>('processingPersonal/getPersonalDataTableSubmit', async ({ data }, { rejectWithValue }) => {
  try {
    const response = await api.get('/personal-data/personal-data/applications', {
      params: data,
    });

    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const getPersonalDataTableRevoke = createAsyncThunk<
  TPersonalDataTableResponse,
  TPersonalDataTableRequest
>('processingPersonal/getPersonalDataTableRevoke', async ({ data }, { rejectWithValue }) => {
  try {
    const response = await api.get('/personal-data/personal-data/revoke/applications', {
      params: data,
    });

    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
